<template>
  <div class="reply-form" :class="{ 'reply-form--open': isOpen }">
    <form
      :action="formAction"
      method="POST"
      class="discussion-form"
      v-if="post"
      ref="form"
    >
      <input type="hidden" name="_method" :value="formMethod" />
      <input type="hidden" name="authenticity_token" :value="formToken" />
      <input
        type="hidden"
        name="discussion_slug"
        :value="post.discussionSlug"
      />

      <div class="discussion-form__image">
        <a :href="post.memberPath" class="content-author__image">
          <img :alt="post.memberName" :src="post.memberAvatar" />
        </a>
      </div>

      <div class="discussion-form__body">
        <text-editor
          ref="editor"
          attachable="discussion_post"
          name="discussion_post[content]"
          :content="post.content"
          :replyToId="replyToId"
        >
        </text-editor>

        <submit-trigger-button v-if="showButton" event-id="post" event-to-trigger="submitPostForm" class="btn btnMd btnRed">Post reply</submit-trigger-button>

        <a class="cancel" href="#" @click.prevent="close" v-if="showButton"
          >Cancel</a
        >
      </div>
    </form>
  </div>
</template>

<script>
import SubmitTriggerButton from "../../shared/SubmitTriggerButton";
import TextEditor from "./TextEditor";
import discussionService from "../../../services/discussion_service";

export default {
  name: "PostForm",
  components: {
    TextEditor,
    SubmitTriggerButton
  },
  props: {
    showButton: {
      type: Boolean,
      default: true
    },
    initEditor: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      post: null,
      isOpen: false,
      replyToId: null
    };
  },
  computed: {
    formAction () {
      let path = "/discussion_posts/";
      if (this.post.id) path += this.post.id;
      return path;
    },
    formMethod () {
      return this.post.id ? "patch" : "post";
    },
    formToken () {
      return document.querySelector('meta[name="csrf-token"]').content;
    }
  },
  watch: {
    isOpen (value) {
      if (value) {
        document.body.classList.add("reply-open");
      } else {
        document.body.classList.remove("reply-open");
      }
    }
  },
  mounted () {
    this.$eventHub.$on("editPost", (postId, replyId) => {
      this.post = discussionService.getData(postId);
      this.replyToId = replyId || this.post.parentId;
      this.expand();
    });

    this.$eventHub.$on("closePostReply", () => {
      this.replyToId = null;
    });

    this.$eventHub.$on("submitPostForm", this.submit);
  },
  methods: {
    close () {
      this.isOpen = false;
      this.post = { content: "" };
    },
    expand () {
      this.isOpen = true;
      this.$refs.editor && this.$refs.editor.focus();
    },
    submit() {
      if (this.$refs.form.checkValidity()) {
        this.$refs.form.submit();
      }
    }
  }
};
</script>
